module.exports = __webpack_public_path__ + "img/solution-finance-img2.cd6c905d.png";